require('./payment-settings.scss')

module.exports = {
  template: require('./payment-settings.pug')()
  controller: require('./payment-settings.ctrl')
  bindings:
    salon: '<'
    onSubmit: '&'
}
